export default {"src":"/_next/static/media/CLS.cf3e3a71.svg","height":18,"width":18};